module.exports = __webpack_public_path__ + "assets/static/media/splash_screen_4.9495cf8f.png";